export const isSingleOrGroupOrderNumber = (orderNumber: string): boolean =>
  orderNumber.toUpperCase().startsWith('BT') || orderNumber.toUpperCase().startsWith('GBT');
